"use strict";
var STATE_EDITED = "edited";
var STATE_EDITING_STARTED = "editing_started";
var STATE_CONFIRMED = "confirmed";
var STATE_UNCONFIRMED = "unconfirmed";
var getState = function(info) {
  if (typeof(info.state) === "undefined" || (info.state !== STATE_EDITED && info.state !== STATE_EDITING_STARTED && info.state !== STATE_CONFIRMED && info.state !== STATE_UNCONFIRMED))
    return STATE_CONFIRMED;
  else
    return info.state;
};
var stateInfo = function(info) {
  if (typeof(info) === "undefined")
    return "(Keine Information)";
  var userName = info.user || "(unbekannt)";
  switch (getState(info)) {
    case STATE_EDITED:
      return "In Bearbeitung durch " + userName;
    case STATE_EDITING_STARTED:
      return "Bearbeitung begonnen durch " + userName;
    case STATE_UNCONFIRMED:
      return "Angelegt von " + userName;
    case STATE_CONFIRMED:
    default:
      return "Bestätigt von " + userName;
  }
};
var canRevert = function(info, loginUser, isWorkflowManager) {
  if (typeof(info) === "undefined" || typeof(loginUser) === "undefined")
    return false;
  var state = getState(info);
  var userName = info.user || "(unbekannt)";
  var stateOk = state === STATE_EDITED || state === STATE_EDITING_STARTED;
  var userOk = userName === loginUser;
  var ok = stateOk && (userOk || typeof(isWorkflowManager) !== "undefined" && isWorkflowManager);
  return ok;
};
var canConfirm = function(info, loginUser, isWorkflowManager) {
  if (typeof(info) === "undefined" || typeof(loginUser) === "undefined")
    return false;
  var state = getState(info);
  var userName = info.user || "(unbekannt)";
  var stateOk = state === STATE_EDITED || state === STATE_EDITING_STARTED || state == STATE_UNCONFIRMED;
  var userOk = userName === loginUser;
  var ok = stateOk && (userOk || typeof(isWorkflowManager) !== "undefined" && isWorkflowManager);
  return ok;
};
module.exports = {
  STATE_EDITED: STATE_EDITED,
  STATE_EDITING_STARTED: STATE_EDITING_STARTED,
  STATE_CONFIRMED: STATE_CONFIRMED,
  STATE_UNCONFIRMED: STATE_UNCONFIRMED,
  stateInfo: stateInfo,
  canRevert: canRevert,
  canConfirm: canConfirm
};
